import React, { useState, useEffect, useRef } from 'react';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(2);
  const [isVisible, setIsVisible] = useState(false);
  const carouselRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      name: "Brandon Sears",
      title: "Operations Supervisor, ApexID",
      image: "/testemonial-1.jpg",
      text: "Our collaboration transformed our digital footprint. The team's dedication and creative input led to outstanding results, perfectly aligning with our vision and greatly exceeding our expectations in every way."
    },
    {
      id: 2,
      name: "Brandon Sears",
      title: "Operations Supervisor, ApexID",
      image: "/testimonial-2.jpg",
      text: "An exceptional experience! The attention to detail and commitment to innovation elevated our project, positioning our brand prominently in a competitive market and creating lasting value for our business."
    },
    {
      id: 3,
      name: "Brandon Sears",
      title: "Operations Supervisor, ApexID",
      image: "/testimonial-3.jpg",
      text: "Working with this team was a pleasure. They consistently went above and beyond, simplifying complex processes and yielding outcomes that were truly extraordinary and valuable for our growth."
    },
    {
      id: 4,
      name: "Brandon Sears",
      title: "Operations Supervisor, ApexID",
      image: "/testimonial-4.jpg",
      text: "Their technical expertise is unparalleled. They delivered beyond expectations, providing intuitive, future-ready solutions that enhanced our systems in ways we hadn't even anticipated."
    },
    {
      id: 5,
      name: "Brandon Sears",
      title: "Operations Supervisor, ApexID",
      image: "/testimonial-2.jpg",
      text: "Their approach brought immense value to our company. Their passion, integrity, and insights were instrumental in achieving our goals, especially in critical areas requiring innovation and thought leadership."
    }
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (carouselRef.current) {
      observer.observe(carouselRef.current);
    }

    return () => {
      if (carouselRef.current) {
        observer.unobserve(carouselRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      const timer = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
      }, 5000);

      return () => clearInterval(timer);
    }
  }, [isVisible]);

  const getCardStyle = (index) => {
    const baseStyle = {
      width: window.innerWidth < 768 ? '280px' : '300px',
      height: window.innerWidth < 768 ? '340px' : '360px',
      padding: '20px',
      borderRadius: '15px',
      textAlign: 'center',
      transition: 'all 0.5s ease',
      position: 'absolute',
      top: window.innerWidth < 768 ? '52%' : '47%', // Increased top position to create more gap
      left: '50%',
      transform: 'translate(-50%, -50%)',
      boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      opacity: isVisible ? 1 : 0,
      transition: 'opacity 1s ease-out, transform 1s ease-out',
      backgroundColor: '#FFFFFF',
    };

    const centerIndex = currentIndex;
    const diff = index - centerIndex;
    const normalizedDiff = ((diff + testimonials.length) % testimonials.length) - 2;

    const getOffset = () => {
      if (window.innerWidth < 768) return normalizedDiff * 300;
      if (window.innerWidth < 1024) return normalizedDiff * 320;
      return normalizedDiff * 340;
    };

    if (normalizedDiff === 0) {
      return {
        ...baseStyle,
        zIndex: 3,
        backgroundColor: '#FFFFFF',
        transform: isVisible ? `translate(-50%, ${window.innerWidth < 768 ? '-60%' : '-55%'}) scale(1.1)` : `translate(-50%, -30%) scale(1.1)`,
      };
    } else {
      const offset = getOffset();
      const scale = 1 - Math.abs(normalizedDiff) * 0.1;
      const opacity = isVisible ? (1 - Math.abs(normalizedDiff) * 0.2) : 0;
      return {
        ...baseStyle,
        zIndex: 2 - Math.abs(normalizedDiff),
        transform: isVisible ? `translate(calc(-50% + ${offset}px), ${window.innerWidth < 768 ? '-60%' : '-55%'}) scale(${scale})` : `translate(calc(-50% + ${offset}px), -30%) scale(${scale})`,
        opacity: opacity,
        display: Math.abs(normalizedDiff) > 2 ? 'none' : 'flex',
      };
    }
  };

  return (
    <div ref={carouselRef} style={{ 
      position: 'relative', 
      height: window.innerWidth < 768 ? '600px' : '700px', // Increased overall height
      overflow: 'hidden', 
      margin: '50px 0',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h2 style={{
        textAlign: 'center',
        color: '#410684',
        fontFamily: '"Oswald", sans-serif',
        fontSize: window.innerWidth < 768 ? '55px' : '60px',
        lineHeight: window.innerWidth < 768 ? '48px' : '72px',
        fontWeight: 700,
        fontStyle: 'normal',
        marginBottom: window.innerWidth < 768 ? '130px' : '150px', // Increased margin for more gap
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(-20px)',
        transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
      }}>
        WHAT OUR CLIENTS SAY
      </h2>

      {testimonials.map((testimonial, index) => (
        <div key={testimonial.id} style={getCardStyle(index)}>
          <p style={{ 
            fontSize: window.innerWidth < 768 ? '13px' : '14px',
            lineHeight: '1.6',
            fontFamily: 'Inter, sans-serif', 
            fontWeight: 400,
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            color: 'rgb(65, 64, 66)',
            marginBottom: '10px',
            flex: '1'
          }}>
            "{testimonial.text}"
          </p>

          <div style={{
            position: 'absolute',
            left: '50%',
            bottom: '70px',
            transform: 'translateX(-50%)',
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            overflow: 'hidden',
            border: '3px solid white',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 2
          }}>
            <img 
              src={testimonial.image} 
              alt={testimonial.name} 
              style={{ 
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }} 
            />
          </div>

          <div style={{
            background: '#410684',
            borderRadius: '0 0 15px 15px',
            padding: '35px 20px 15px',
            marginLeft: '-20px',
            marginRight: '-20px',
            marginBottom: '-20px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
          }}>
            <div style={{ 
              textAlign: 'center',
              marginTop: '2px'
            }}>
              <h3 style={{ 
                fontSize: '17px',
                fontFamily: '"Oswald", sans-serif',
                fontWeight: 500,
                color: '#fff',
                margin: '0 0 0 0'
              }}>
                {testimonial.name}
              </h3>
              <h4 style={{ 
                fontSize: '11px',
                fontFamily: '"Inter", sans-serif',
                fontWeight: 400,
                marginBottom:'9px',
                fontStyle: 'italic',
                color: '#fff',
                margin: 0,
                opacity: 0.95
              }}>
                {testimonial.title}
              </h4>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TestimonialCarousel;